import { messageHooksFactory } from '@nxte-nl/message-hooks';

import { defaultUserPreFillData } from '../../constants/account';
import { defaultFeatureToggles } from '../../constants/featureToggle';
import { defaultBillingFields } from '../../constants/forms';
import {
  AccountMessages,
  AppDataGiftCardCategories,
  AppDataPopularSearchResults,
  AppDataStoreData,
  BasketMessages,
  CheckoutAddressEditMessages,
  CheckoutMessages,
  Filters,
  GlobalMessages,
  MapMessages,
  Messages,
  ProductOverviewModalMessages,
  RedeemMessages,
  Signals,
  StoreSwitcherMessages,
} from '../../types/Messages';

export const messageHooks = messageHooksFactory<Messages, Signals>({
  [CheckoutMessages.ProductsQuantity]: 1,
  [CheckoutMessages.CheckoutBillingInfo]: { ...defaultBillingFields },
  [ProductOverviewModalMessages.DeliveryInfo]: [],
  [ProductOverviewModalMessages.ReceiverName]: '',
  [ProductOverviewModalMessages.AddressFormDisabled]: false,
  [ProductOverviewModalMessages.DigitalAddressFormDisabled]: false,
  [ProductOverviewModalMessages.IsOrderExists]: false,

  [CheckoutAddressEditMessages.CheckoutAddressEditing]: false,

  [RedeemMessages.RedeemDoublerModalOpened]: false,
  [RedeemMessages.ShouldAddPhysicalAddress]: false,
  [RedeemMessages.ShouldAddDigitalAddress]: false,
  [RedeemMessages.IsExternalLinks]: false,

  [GlobalMessages.OpenModals]: [],
  [GlobalMessages.PageEntityLoading]: false,
  [GlobalMessages.PageContentLoading]: false,
  [GlobalMessages.MutationInProgress]: false,
  [GlobalMessages.FeatureToggles]: defaultFeatureToggles,
  [GlobalMessages.FeatureTogglesLoaded]: false,

  [AppDataGiftCardCategories.Loading]: false,
  [AppDataPopularSearchResults.Loading]: false,
  [AppDataStoreData.Loading]: false,

  [MapMessages.PDPLocations]: null,
  [MapMessages.LocationsListLoading]: false,

  [AccountMessages.AccountUserPreFillData]: defaultUserPreFillData,

  [Filters.AvailableFilters]: [],
  [Filters.TotalItems]: 0,
  [Filters.AppliedFiltersAmount]: 0,
  [Filters.SelectedFilters]: [],

  [GlobalMessages.Language]: '',

  [StoreSwitcherMessages.isNonBlockPart]: false,
  [BasketMessages.isCartSet]: false,
});
